export default __webpack_public_path__ + "static/media/DSC05827.32a62a8f.jpg";